var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#EE5B09"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.66016C6.75537 6.66016 3.40625 10.9993 3.40625 10.9993C3.40625 10.9993 6.75537 15.339 11 15.339C14.2456 15.339 18.5938 10.9993 18.5938 10.9993C18.5938 10.9993 14.2456 6.66016 11 6.66016ZM11 13.7027C9.50937 13.7027 8.29606 12.4899 8.29606 10.9993C8.29606 9.50866 9.50937 8.29534 11 8.29534C12.4906 8.29534 13.7039 9.50866 13.7039 10.9993C13.7039 12.4899 12.4906 13.7027 11 13.7027ZM11 9.42091C10.7903 9.41695 10.5818 9.45484 10.3869 9.53237C10.192 9.60989 10.0144 9.7255 9.86471 9.87244C9.71498 10.0194 9.59604 10.1947 9.51484 10.3881C9.43365 10.5815 9.39183 10.7892 9.39183 10.999C9.39183 11.2088 9.43365 11.4165 9.51484 11.6099C9.59604 11.8033 9.71498 11.9786 9.86471 12.1256C10.0144 12.2725 10.192 12.3881 10.3869 12.4656C10.5818 12.5432 10.7903 12.5811 11 12.5771C11.4134 12.5693 11.8072 12.3996 12.0968 12.1045C12.3864 11.8094 12.5486 11.4125 12.5486 10.999C12.5486 10.5855 12.3864 10.1886 12.0968 9.8935C11.8072 9.5984 11.4134 9.42871 11 9.42091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewicon);
export default __webpack_public_path__ + "static/media/viewicon.7d996c8d5dcd16b361883c52e3c7625c.svg";
export { ForwardRef as ReactComponent };